import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

@Entity()
export class SuppressedContact extends MongoEntity {
  static override _class = 'SuppressedContact';
  static override _collectionName = 'suppressed_contacts';

  @Field(type => String) email!: string;
  @Field(type => String) date!: string;
}
